import { Select } from '@common/ui'

export enum SupportedEntitySelectorType {
  All,
  Single,
  FieldValueEquals,
  FieldValueEqualsUserFieldValue,
  FieldValueEqualsUserEntityId,
}

type EntitySelectorTypeProps = {
  optionsWithLabels: Map<SupportedEntitySelectorType, string>
  selected: SupportedEntitySelectorType
  setSelected: (type: SupportedEntitySelectorType) => void
  disabled?: boolean
}

const EntitySelectorTypeInput = ({ optionsWithLabels, selected, setSelected, disabled }: EntitySelectorTypeProps) => (
  <Select
    label="Filter"
    w={160}
    style={{ flexShrink: 0 }}
    disabled={disabled}
    value={String(selected)}
    data={Array.from(optionsWithLabels.entries()).map(([type, label]) => ({ value: String(type), label }))}
    onChange={(value) => {
      if (value !== null) setSelected(Number(value) as SupportedEntitySelectorType)
    }}
    allowDeselect={false}
    searchable={false}
    clearable={false}
  />
)

export default EntitySelectorTypeInput
